import type { CrbInternalId } from '@gcv/shared';
import { FriendlyCrbAccountType } from '@gcv/shared';

export const getAccountLabel = (accountNumber: string, account?: CrbInternalId) => {
  const accountNumberSlice = `*${accountNumber.slice(-4)}`;
  if (account?.name) {
    return `${account.name} ${accountNumberSlice}`;
  } else if (account?.type) {
    return `${FriendlyCrbAccountType[account.type]} ${accountNumberSlice}`;
  } else {
    return accountNumberSlice;
  }
};
